import React, { useState, useEffect } from "react";
import './Egg.css';

function Egg() {
  const [isBouncing, setIsBouncing] = useState(false);
  const [eggPosition, setEggPosition] = useState(5);
  const [eggRotation, setEggRotation] = useState(0);
  const [isRolling, setIsRolling] = useState(true);

  // Egg dimensions (approximate size of emoji)
  const EGG_HEIGHT = 48;
  const EGG_WIDTH = 40;
  
  // Calculate circumference of egg ellipse: C ≈ π(a + b) where a and b are semi-axes
  const EGG_CIRCUMFERENCE = Math.PI * (EGG_HEIGHT / 2 + EGG_WIDTH / 2);

  const getVerticalOffset = (rotation) => {
    // Calculate vertical offset so the bottom contact point stays at same horizon
    const angle = (rotation % 360) * Math.PI / 180;
    
    // Distance from center to edge at given angle (approximate as ellipse)
    const radius = (EGG_HEIGHT * EGG_WIDTH) / Math.sqrt(
      Math.pow(EGG_WIDTH * Math.sin(angle), 2) + Math.pow(EGG_HEIGHT * Math.cos(angle), 2)
    );
    
    // Offset to keep bottom at same horizon (reduced by 0.5 factor for subtler movement)
    const offset = ((EGG_HEIGHT / 2) - radius) * 0.5;
    return offset;
  };

  const handleEggClick = () => {
    // Always trigger bounce
    if (!isBouncing) {
      setIsBouncing(true);
      setTimeout(() => {
        setIsBouncing(false);
      }, 600);
    }
    
    // Toggle rolling
    setIsRolling(prev => {
      if (prev) {
        // Turning off: roll back to original position
        const distance = eggPosition - 5; // distance to roll back
        const rotationChange = (distance / EGG_CIRCUMFERENCE) * 360;
        const newRotation = eggRotation + rotationChange;
        
        setEggPosition(5);
        setEggRotation(newRotation);
      }
      return !prev;
    });
  };

  useEffect(() => {
    if (!isRolling) return;

    const rollEgg = () => {
      const oldPosition = eggPosition;
      let randomPosition = Math.random() * (window.innerWidth - 100) + 5;
      let distance = oldPosition - randomPosition; // negative if rolling right, positive if rolling left
      
      // Ensure minimum distance for at least one full rotation (360 degrees)
      const minDistance = EGG_CIRCUMFERENCE; // minimum for 360 degrees
      if (Math.abs(distance) < minDistance) {
        // Adjust position to ensure full rotation, maintain direction
        if (distance >= 0) {
          // Rolling left
          randomPosition = Math.max(5, oldPosition - minDistance);
          distance = oldPosition - randomPosition;
        } else {
          // Rolling right
          randomPosition = Math.min(window.innerWidth - 100, oldPosition + minDistance);
          distance = oldPosition - randomPosition;
        }
      }
      
      // Calculate rotation based on distance and circumference
      // One full rotation (360°) = one circumference traveled
      const rotationChange = (distance / EGG_CIRCUMFERENCE) * 360;
      const newRotation = eggRotation + rotationChange;
      
      setEggPosition(randomPosition);
      setEggRotation(newRotation);
    };

    const interval = setInterval(rollEgg, 3000 + Math.random() * 2000);
    return () => clearInterval(interval);
  }, [eggPosition, eggRotation, isRolling]);

  return (
    <div 
      className={`egg-emoji ${isBouncing ? 'bounce' : ''}`} 
      onClick={handleEggClick}
      style={{ 
        right: `${eggPosition}px`,
        '--egg-rotation': `${eggRotation}deg`,
        '--vertical-offset': `${getVerticalOffset(eggRotation)}px`
      }}
    >
      🥚
    </div>
  );
}

export default Egg;

